export default "__VITE_ASSET__CrIGYhNB__"